import { Card, CardHeader, CardBody, Skeleton, Tooltip } from "@heroui/react";
import { ThemedText } from "@/components/ui";
import { formatThousands, formatDate } from "@/utils";
import { LuTrendingUp, LuTrendingDown, LuInfo } from "react-icons/lu";

const SkeletonRow = () => (
    <div className="flex items-center justify-between py-2.5">
        <div className="flex flex-col gap-1">
            <Skeleton className="h-4 w-32 rounded-md" />
            <Skeleton className="h-3 w-20 rounded-md" />
        </div>
        <Skeleton className="h-5 w-16 rounded-md" />
    </div>
);

const RecentStockCard = ({ stocks, isLoading }) => {
    return (
        <Card className="border-default-200 border" shadow="none">
            <CardHeader className="flex flex-row items-center gap-1.5 px-4 pt-4 pb-0">
                <Tooltip
                    content="7 aktivitas stok masuk & keluar terbaru dari semua gudang"
                    placement="right"
                >
                    <span className="cursor-help text-default-400">
                        <LuInfo size={12} />
                    </span>
                </Tooltip>
                <ThemedText size="md" className="font-semibold">
                    Pergerakan Stok
                </ThemedText>
            </CardHeader>
            <CardBody className="px-4 pt-2 pb-4">
                <div className="divide-default-100 divide-y">
                    {isLoading ? (
                        Array.from({ length: 7 }).map((_, i) => (
                            <SkeletonRow key={i} />
                        ))
                    ) : stocks?.length > 0 ? (
                        stocks.map((item) => (
                            <div
                                key={item.id}
                                className="flex items-center justify-between py-2.5"
                            >
                                <div className="flex flex-col gap-0.5">
                                    <ThemedText size="sm">
                                        {item.material_name}
                                    </ThemedText>
                                    <ThemedText
                                        variant="secondary"
                                        size="xs"
                                        className="line-clamp-1"
                                    >
                                        {item.warehouse_name} &middot;{" "}
                                        {formatDate(item.date)}
                                    </ThemedText>
                                </div>
                                <div className="flex items-center gap-1.5">
                                    {item.qty_in ? (
                                        <>
                                            <LuTrendingUp
                                                size={14}
                                                className="text-success"
                                            />
                                            <ThemedText size="xs">
                                                {formatThousands(item.qty_in)}{" "}
                                                {item.unit_name}
                                            </ThemedText>
                                        </>
                                    ) : (
                                        <>
                                            <LuTrendingDown
                                                size={14}
                                                className="text-danger"
                                            />
                                            <ThemedText size="xs">
                                                {formatThousands(item.qty_out)}{" "}
                                                {item.unit_name}
                                            </ThemedText>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="py-8 text-center">
                            <ThemedText variant="secondary" size="sm">
                                Belum ada pergerakan stok.
                            </ThemedText>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default RecentStockCard;
